<template>
	<div>
		<q-table
			ref="table"
			:data="certificates"
			:columns="columns_certificates"
			row-key="id"
			:pagination.sync="server_pagination"
			@request="requestCertificates"
			:loading="loading"
			:no-data-label="$t('no_data_avaliable')"
			:no-results-label="$t('no_results_found')"
			:loading-label="$t('loading_data')"
			:rows-per-page-label="$t('items_per_page')"
			:rows-per-page-options="[5, 10, 50, 100]"
			:filter="filter_users"
			binary-state-sort
			class="q-mt-lg"
			v-if="!useTrailSubscription"
		>
			<template slot="top" slot-scope="props" :props="props">
				<q-search
					v-model="filter_users"
					icon="far fa-search"
					:placeholder="$t('search')"
					:debounce="500"
				/>

				<div class="col" />
				<q-btn
					color="secondary"
					icon="fas fa-download"
					:label="$t('certified_report')"
					@click="downloadCertificate()"
				/>
			</template>

			<q-tr slot="header" slot-scope="props" :props="props">
				<q-th v-for="col in props.cols" :key="col.name" :props="props">
					{{ $t(col.label) }}
				</q-th>
			</q-tr>
			<template slot="body" slot-scope="props">
				<q-tr :props="props">
					<q-td key="user_full_name" :props="props">
						{{ props.row.user_full_name }}
					</q-td>

					<q-td key="user_email" :props="props">
						{{ props.row.user_email }}
					</q-td>

					<q-td key="result_date" :props="props">
						{{ props.row.result_date }}
					</q-td>

					<q-td key="status" :props="props" auto-width>
						<q-chip
							small
							:icon="getIconStatus(props.row.status)"
							:color="getColorStatus(props.row.status)"
							class="full-width text-center"
						>
							{{ $t(getTextStatus(props.row.status)) }}
						</q-chip>
					</q-td>

					<q-td key="user_branches" :props="props">
						<q-btn
							color="primary"
							text-color="white"
							:label="props.row.user_branches.length"
							no-ripple
						>
							<q-tooltip>
								<p
									v-if="props.row.user_branches.length > 0"
									class="tooltip q-mb-sm"
								>
									{{ $t('branches') }}:
									<span
										v-for="(branch, index) in props.row.user_branches"
										:key="index"
									>
										{{ branch }}
										<span v-if="props.row.user_branches.length - 1 > index"
											>,
										</span>
									</span>
								</p>
							</q-tooltip>
						</q-btn>
					</q-td>
				</q-tr>
			</template>
		</q-table>

		<q-tabs color="secondary" v-model="report" v-if="useTrailSubscription">
			<q-tab slot="title" name="mandatory" :label="$t('mandatory')" />
			<q-tab slot="title" name="enrolled" :label="$t('enrolled')" />

			<q-tab-pane name="mandatory">
				<q-table
					ref="table"
					:data="mandatory"
					:columns="columns"
					row-key="id"
					:pagination.sync="server_pagination_mandatory"
					@request="requestMandatoryCertificates"
					:loading="loading"
					:no-data-label="$t('no_data_avaliable')"
					:no-results-label="$t('no_results_found')"
					:loading-label="$t('loading_data')"
					:rows-per-page-label="$t('items_per_page')"
					:rows-per-page-options="[5, 10, 50, 100]"
					:filter="filter_certificates_mandatory"
					binary-state-sort
				>
					<template slot="top" slot-scope="props" :props="props">
						<q-search
							v-model="filter_certificates_mandatory"
							icon="far fa-search"
							:placeholder="$t('search')"
							:debounce="500"
						/>

						<div class="col" />
						<q-btn
							color="secondary"
							icon="fas fa-download"
							:label="$t('certified_report')"
							@click="downloadCertificate()"
						/>
					</template>

					<q-tr slot="header" slot-scope="props" :props="props">
						<q-th v-for="col in props.cols" :key="col.name" :props="props">
							{{ $t(col.label) }}
						</q-th>
					</q-tr>

					<template slot="body" slot-scope="props">
						<q-tr :props="props">
							<q-td key="full_name" :props="props">
								{{ props.row.full_name }}
							</q-td>

							<q-td key="email" :props="props">
								{{ props.row.email }}
							</q-td>

							<q-td key="result_date" :props="props">
								{{ props.row.result_date }}
							</q-td>

							<q-td key="score" :props="props">
								{{ props.row.score ? props.row.score.toFixed(2) : '' }}
							</q-td>

							<q-td key="percent" :props="props">
								{{ props.row.percent ? `${props.row.percent.toFixed(2)}%` : '' }}
							</q-td>

							<q-td key="status" :props="props" auto-width>
								<q-chip
									small
									:icon="getIconStatus(props.row.status)"
									:color="getColorStatus(props.row.status)"
									class="full-width text-center"
								>
									{{ $t(getTextStatus(props.row.status)) }}
								</q-chip>
							</q-td>

							<q-td key="user_branches" :props="props">
								<q-btn
									color="primary"
									text-color="white"
									:label="
										props.row.user_branches ? props.row.user_branches.length : 0
									"
									no-ripple
								>
									<q-tooltip>
										<p
											v-if="
												props.row.user_branches &&
													props.row.user_branches.length > 0
											"
											class="tooltip q-mb-sm"
										>
											{{ $t('branches') }}:
											<span
												v-for="(branch, index) in props.row.user_branches"
												:key="index"
											>
												{{ branch }}
												<span
													v-if="
														props.row.user_branches.length - 1 > index
													"
													>,
												</span>
											</span>
										</p>
									</q-tooltip>
								</q-btn>
							</q-td>
						</q-tr>
					</template>
				</q-table>
			</q-tab-pane>

			<q-tab-pane name="enrolled">
				<q-table
					ref="table"
					:data="enrolled"
					:columns="columns_enrolled_users"
					row-key="id"
					:pagination.sync="server_pagination_enrolled"
					@request="requestEnrolledCertificates"
					:loading="loading"
					:no-data-label="$t('no_data_avaliable')"
					:no-results-label="$t('no_results_found')"
					:loading-label="$t('loading_data')"
					:rows-per-page-label="$t('items_per_page')"
					:rows-per-page-options="[5, 10, 50, 100]"
					:filter="filter_certificates_enrolled"
					binary-state-sort
				>
					<template slot="top" slot-scope="props" :props="props">
						<q-search
							v-model="filter_certificates_enrolled"
							icon="far fa-search"
							:placeholder="$t('search')"
							:debounce="500"
						/>

						<div class="col" />

						<q-btn
							color="secondary"
							icon="fas fa-plus"
							:label="$t('enroll_users')"
							class="q-mr-md"
							@click="showEnrollUsers()"
						/>
					</template>

					<q-tr slot="header" slot-scope="props" :props="props">
						<q-th v-for="col in props.cols" :key="col.name" :props="props">
							{{ $t(col.label) }}
						</q-th>
					</q-tr>

					<template slot="body" slot-scope="props">
						<q-tr :props="props">
							<q-td key="full_name" :props="props">
								{{ props.row.full_name }}
							</q-td>

							<q-td key="email" :props="props">
								{{ props.row.email }}
							</q-td>

							<q-td key="result_date" :props="props">
								{{ props.row.result_date }}
							</q-td>

							<q-td key="score" :props="props">
								{{ props.row.score ? props.row.score.toFixed(2) : '' }}
							</q-td>

							<q-td key="percent" :props="props">
								{{ props.row.percent ? `${props.row.percent.toFixed(2)}%` : '' }}
							</q-td>

							<q-td key="status" :props="props" auto-width>
								<q-chip
									small
									:icon="getIconStatusEnrolled(props.row)"
									:color="getColorStatusEnrolled(props.row)"
									class="full-width text-center"
								>
									{{ $t(getTextStatusEnrolled(props.row)) }}
								</q-chip>
							</q-td>

							<q-td key="user_branches" :props="props">
								<q-btn
									color="primary"
									text-color="white"
									:label="
										props.row.user_branches ? props.row.user_branches.length : 0
									"
									no-ripple
								>
									<q-tooltip>
										<p
											v-if="
												props.row.user_branches &&
													props.row.user_branches.length > 0
											"
											class="tooltip q-mb-sm"
										>
											{{ $t('branches') }}:
											<span
												v-for="(branch, index) in props.row.user_branches"
												:key="index"
											>
												{{ branch }}
												<span
													v-if="
														props.row.user_branches.length - 1 > index
													"
													>,
												</span>
											</span>
										</p>
									</q-tooltip>
								</q-btn>
							</q-td>

							<q-td auto-width key="actions" :props="props">
								<q-btn
									flat
									round
									color="negative"
									icon="far fa-trash-alt"
									@click="removeEnrolledUser(props.row.actions)"
								/>
							</q-td>
						</q-tr>
					</template>
				</q-table>
			</q-tab-pane>
		</q-tabs>

		<div class="row gutter-sm justify-end q-mt-sm" v-if="status == 1">
			<div class="col-xs-12 col-sm-4">
				<q-btn
					color="secondary"
					class="full-width"
					:label="$t('notify_pending_users')"
					icon="far fa-paper-plane"
					@click="showNotifyUsers"
				/>
			</div>
		</div>

		<q-modal
			v-model="show_notify_users"
			:content-css="{ minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '80vh' }"
			no-backdrop-dismiss
			no-esc-dismiss
		>
			<q-modal-layout>
				<q-toolbar slot="header">
					<q-btn
						flat
						round
						dense
						@click="show_notify_users = false"
						icon="fas fa-times"
					/>
					<q-toolbar-title>
						{{ $t('notify_pending_users') }}
					</q-toolbar-title>
				</q-toolbar>

				<div class="layout-padding">
					<q-table
						ref="table"
						:data="users_notify"
						:columns="columns_notify_users"
						row-key="user_id"
						:pagination.sync="server_pagination"
						@request="requestNotifyUsers"
						:loading="loading"
						:filter="filter"
						selection="multiple"
						:selected.sync="users_notify_selected"
						:no-data-label="$t('no_data_avaliable')"
						:no-results-label="$t('no_results_found')"
						:loading-label="$t('loading_data')"
						:rows-per-page-label="$t('items_per_page')"
						:rows-per-page-options="[5, 10, 50, 100]"
						binary-state-sort
						class="q-mt-lg"
					>
						<template slot="top" slot-scope="props" :props="props">
							<q-search
								v-model="filter"
								icon="far fa-search"
								:placeholder="$t('search')"
								:debounce="500"
							/>

							<div class="col" />
						</template>

						<q-tr slot="header" slot-scope="props" :props="props">
							<q-th auto-width>
								<q-checkbox v-model="props.selected" indeterminate-value="some" />
							</q-th>

							<q-th v-for="col in props.cols" :key="col.name" :props="props">
								{{ $t(col.label) }}
							</q-th>
						</q-tr>

						<template slot="body" slot-scope="props">
							<q-tr :props="props">
								<q-td auto-width>
									<q-checkbox color="primary" v-model="props.selected" />
								</q-td>

								<q-td key="user_full_name" :props="props">
									{{ props.row.user_full_name }}
								</q-td>

								<q-td key="user_email" :props="props">
									{{ props.row.user_email }}
								</q-td>

								<q-td key="user_profile" :props="props">
									{{ props.row.user_profile }}
								</q-td>
							</q-tr>
						</template>
					</q-table>

					<div class="row gutter-sm justify-end q-mt-sm" v-if="status == 1">
						<div class="col-xs-12 col-sm-4">
							<q-btn
								color="primary"
								class="full-width"
								:label="$t('notify_selected_users')"
								icon="far fa-check-square"
								@click="confirmTypeNotification('selected')"
								:disable="users_notify_selected.length === 0"
							/>
						</div>

						<div class="col-xs-12 col-sm-4">
							<q-btn
								color="secondary"
								class="full-width"
								:label="$t('notify_all_users')"
								icon="far fa-users"
								@click="confirmTypeNotification('all')"
							/>
						</div>
					</div>
				</div>
			</q-modal-layout>
		</q-modal>

		<q-dialog v-model="show_select_notification_message">
			<span slot="title">{{
				$t(type_notification === 'all' ? 'notify_all_users' : 'notify_selected_users')
			}}</span>

			<span slot="body">
				{{ $t('what_kind_of_message_you_want_to_send') }}
			</span>

			<template slot="buttons" slot-scope="props" :props="props">
				<q-btn
					color="tertiary"
					:label="$t('personalized')"
					@click="showPersonalizeMessage()"
				/>
				<q-btn color="positive" :label="$t('default')" @click="notifyUsers('default')" />
			</template>
		</q-dialog>

		<q-modal
			v-model="personalize_message"
			:content-css="{ minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '80vh' }"
			no-backdrop-dismiss
			no-esc-dismiss
		>
			<q-modal-layout>
				<q-toolbar slot="header">
					<q-btn
						flat
						round
						dense
						@click="personalize_message = false"
						icon="fas fa-times"
					/>
					<q-toolbar-title>
						{{ $t('personalize_message') }}
					</q-toolbar-title>
				</q-toolbar>

				<div class="layout-padding">
					<div class="row gutter-sm">
						<div class="col-12">
							<q-input
								v-model="notification_title"
								:float-label="$t('title')"
								:error="$v.notification_title.$error"
								@input="$v.notification_title.$touch"
							/>
						</div>

						<div class="col-12">
							<p class="caption">{{ $t('message') }}</p>

							<q-editor
								v-model="notification_body"
								:error="$v.notification_body.$error"
								@input="$v.notification_body.$touch"
								:toolbar="[
									['bold', 'italic', 'strike', 'underline'],
									['left', 'center', 'right', 'justify'],
									['link', 'upload'],
									[
										{
											label: null,
											icon: 'fas fa-font',
											fixedLabel: true,
											fixedIcon: true,
											list: 'no-icons',
											options: [
												'p',
												'h1',
												'h2',
												'h3',
												'h4',
												'h5',
												'h6',
												'code',
											],
										},
										{
											label: null,
											icon: 'fas fa-text-height',
											fixedLabel: true,
											fixedIcon: true,
											list: 'no-icons',
											options: [
												'size-1',
												'size-2',
												'size-3',
												'size-4',
												'size-5',
												'size-6',
												'size-7',
											],
										},
										'removeFormat',
									],
									['quote', 'unordered', 'ordered'],
								]"
								:definitions="{
									bold: { label: null, icon: 'fas fa-bold' },
									italic: { label: null, icon: 'fas fa-italic' },
									strike: { label: null, icon: 'fas fa-strikethrough' },
									underline: { label: null, icon: 'fas fa-underline' },
									left: { label: null, icon: 'fas fa-align-left' },
									center: { label: null, icon: 'fas fa-align-center' },
									right: { label: null, icon: 'fas fa-align-right' },
									justify: { label: null, icon: 'fas fa-align-justify' },
									link: { label: null, icon: 'fas fa-link' },
									removeFormat: { label: null, icon: 'fas fa-eraser' },
									quote: { label: null, icon: 'fas fa-quote-right' },
									unordered: { label: null, icon: 'fas fa-list-ul' },
									ordered: { label: null, icon: 'fas fa-list-ol' },
								}"
							>
							</q-editor>
						</div>
					</div>

					<div class="row gutter-sm justify-end q-mt-sm">
						<div class="col-xs-12 col-sm-3" :class="getOrder('cancel')">
							<q-btn
								color="tertiary"
								class="full-width"
								:label="$t('cancel')"
								icon="far fa-chevron-left"
								@click="personalize_message = false"
							/>
						</div>

						<div class="col-xs-12 col-sm-3" :class="getOrder('save')">
							<q-btn
								color="secondary"
								class="full-width"
								:label="$t('send')"
								icon="far fa-paper-plane"
								@click="notifyUsers('personalized')"
							/>
						</div>
					</div>
				</div>
			</q-modal-layout>
		</q-modal>

		<q-dialog v-model="users_notified" @ok="users_notified = false">
			<span slot="title">{{ $t('notify_pending_users') }}</span>

			<span slot="body">
				{{ $t('pending_users_were_notified') }}
			</span>
		</q-dialog>

		<q-modal
			v-model="show_enroll_users"
			:content-css="{ minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '80vh' }"
			no-backdrop-dismiss
			no-esc-dismiss
		>
			<q-modal-layout>
				<q-toolbar slot="header">
					<q-btn
						flat
						round
						dense
						@click="show_enroll_users = false"
						icon="fas fa-times"
					/>
					<q-toolbar-title>
						{{ $t('enroll_users') }}
					</q-toolbar-title>
				</q-toolbar>

				<div class="layout-padding">
					<q-table
						:data="users_to_enroll"
						:columns="columns_enroll_user"
						:pagination.sync="server_pagination_users_to_enroll"
						@request="requestUsersToEnroll"
						:loading="loading"
						selection="multiple"
						:selected.sync="selected_users_to_enroll"
						:filter="filter_certificates_users_to_enroll"
						row-key="id"
						:no-data-label="$t('no_data_avaliable')"
						:no-results-label="$t('no_results_found')"
						:loading-label="$t('loading_data')"
						:rows-per-page-label="$t('items_per_page')"
						:rows-per-page-options="[5, 10, 50, 100]"
						binary-state-sort
					>
						<template slot="top" slot-scope="props">
							<q-search
								v-model="filter_certificates_users_to_enroll"
								icon="far fa-search"
								:placeholder="$t('search')"
								:debounce="500"
							/>

							<div class="col" />

							<q-btn
								color="positive"
								v-if="selected_users_to_enroll.length > 0"
								icon="far fa-save"
								:label="$t('enroll')"
								@click="enrollUsers()"
							/>
						</template>

						<q-tr slot="header" slot-scope="props" :props="props">
							<q-th auto-width>
								<q-checkbox v-model="props.selected" indeterminate-value="some" />
							</q-th>

							<q-th v-for="col in props.cols" :key="col.name" :props="props">
								{{ $t(col.label) }}
							</q-th>
						</q-tr>

						<q-tr slot="body" slot-scope="props" :props="props">
							<q-td auto-width>
								<q-checkbox color="primary" v-model="props.selected" />
							</q-td>

							<q-td key="id" :props="props">
								{{ props.row.id }}
							</q-td>

							<q-td key="full_name" :props="props">
								{{ props.row.full_name }}
							</q-td>

							<q-td key="email" :props="props">
								{{ props.row.email }}
							</q-td>

							<q-td key="user_branches" :props="props">
								<q-btn
									color="primary"
									text-color="white"
									:label="
										props.row.user_branches ? props.row.user_branches.length : 0
									"
									no-ripple
								>
									<q-tooltip>
										<p
											v-if="
												props.row.user_branches &&
													props.row.user_branches.length > 0
											"
											class="tooltip q-mb-sm"
										>
											{{ $t('branches') }}:
											<span
												v-for="(branch, index) in props.row.user_branches"
												:key="index"
											>
												{{ branch }}
												<span
													v-if="
														props.row.user_branches.length - 1 > index
													"
													>,
												</span>
											</span>
										</p>
									</q-tooltip>
								</q-btn>
							</q-td>
						</q-tr>
					</q-table>
				</div>
			</q-modal-layout>
		</q-modal>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { date } from 'quasar'
const { formatDate } = date
import { required, requiredIf } from 'vuelidate/lib/validators'

export default {
	props: ['load', 'status', 'id'],

	data() {
		return {
			server_pagination: {
				page: 1,
				rowsNumber: 10,
				rowsPerPage: null,
				descending: false,
				sortBy: null,
			},
			certificates: [],
			columns_certificates: [
				{
					name: 'user_full_name',
					required: true,
					label: 'name',
					align: 'left',
					field: 'user_full_name',
					sortable: true,
				},
				{
					name: 'user_email',
					required: true,
					label: 'email',
					align: 'left',
					field: 'user_email',
					sortable: true,
				},
				{
					name: 'result_date',
					required: true,
					label: 'date',
					align: 'left',
					field: 'result_date',
					sortable: true,
				},
				{
					name: 'status',
					required: true,
					label: 'status',
					align: 'left',
					field: 'status',
					sortable: true,
				},
				{
					name: 'user_branches',
					required: true,
					label: 'branches',
					align: 'center',
					field: 'user_branches',
					sortable: false,
				},
			],
			loading: false,
			confirm_notify_users: false,
			users_notified: false,
			show_notify_users: false,
			columns_notify_users: [
				{
					name: 'user_full_name',
					required: true,
					label: 'name',
					align: 'left',
					field: 'user_full_name',
					sortable: true,
				},
				{
					name: 'user_email',
					required: true,
					label: 'email',
					align: 'left',
					field: 'user_email',
					sortable: true,
				},
				{
					name: 'user_profile',
					required: true,
					label: 'profile',
					align: 'left',
					field: 'user_profile',
					sortable: true,
				},
			],
			users_notify: [],
			users_notify_selected: [],
			type_notification: '',
			show_select_notification_message: false,
			personalize_message: false,
			notification_title: '',
			notification_body: '',
			type_message: '',
			filter: '',
			filter_users: '',
			filter_certificates: '',
			report: 'mandatory',
			mandatory: [],
			server_pagination_mandatory: {
				page: 1,
				rowsNumber: 10,
				rowsPerPage: 5,
				descending: false,
				sortBy: null,
			},
			filter_certificates_mandatory: '',
			enrolled: [],
			server_pagination_enrolled: {
				page: 1,
				rowsNumber: 10,
				rowsPerPage: 5,
				descending: false,
				sortBy: null,
			},
			filter_certificates_enrolled: '',
			columns: [
				{
					name: 'full_name',
					required: true,
					label: 'name',
					align: 'left',
					field: 'full_name',
					sortable: true,
				},
				{
					name: 'email',
					required: true,
					label: 'email',
					align: 'left',
					field: 'email',
					sortable: true,
				},
				{
					name: 'result_date',
					required: true,
					label: 'date',
					align: 'left',
					field: 'result_date',
					sortable: true,
				},
				{
					name: 'score',
					required: true,
					label: 'score',
					align: 'left',
					field: 'score',
					sortable: true,
				},
				{
					name: 'percent',
					required: true,
					label: 'percent',
					align: 'left',
					field: 'percent',
					sortable: true,
				},
				{
					name: 'status',
					required: true,
					label: 'status',
					align: 'left',
					field: 'status',
					sortable: true,
				},
				{
					name: 'user_branches',
					required: true,
					label: 'branches',
					align: 'center',
					field: 'user_branches',
					sortable: false,
				},
			],
			columns_enrolled_users: [
				{
					name: 'full_name',
					required: true,
					label: 'name',
					align: 'left',
					field: 'full_name',
					sortable: true,
				},
				{
					name: 'email',
					required: true,
					label: 'email',
					align: 'left',
					field: 'email',
					sortable: true,
				},
				{
					name: 'result_date',
					required: true,
					label: 'date',
					align: 'left',
					field: 'result_date',
					sortable: true,
				},
				{
					name: 'score',
					required: true,
					label: 'score',
					align: 'left',
					field: 'score',
					sortable: true,
				},
				{
					name: 'percent',
					required: true,
					label: 'percent',
					align: 'left',
					field: 'percent',
					sortable: true,
				},
				{
					name: 'status',
					required: true,
					label: 'status',
					align: 'left',
					field: 'status',
					sortable: true,
				},
				{
					name: 'user_branches',
					required: true,
					label: 'branches',
					align: 'center',
					field: 'user_branches',
					sortable: false,
				},
				{
					name: 'actions',
					required: true,
					label: '',
					align: 'center',
					field: 'actions',
					sortable: false,
				},
			],
			show_enroll_users: false,
			server_pagination_users_to_enroll: {
				page: 1,
				rowsNumber: 10,
				rowsPerPage: 5,
				descending: false,
				sortBy: null,
			},
			users_to_enroll: [],
			filter_certificates_users_to_enroll: '',
			columns_enroll_user: [
				{
					name: 'id',
					required: true,
					label: '#',
					align: 'left',
					field: 'id',
					sortable: false,
				},
				{
					name: 'full_name',
					required: true,
					label: 'name',
					align: 'left',
					field: 'full_name',
					sortable: true,
				},
				{
					name: 'email',
					required: true,
					label: 'email',
					align: 'left',
					field: 'email',
					sortable: true,
				},
				{
					name: 'user_branches',
					required: true,
					label: 'branches',
					align: 'center',
					field: 'user_branches',
					sortable: false,
				},
			],
			selected_users_to_enroll: [],
		}
	},

	computed: {
		...mapGetters({
			access_token: 'common/access_token',
			clients: 'params/clients',
			id_user_client_selected: 'common/id_user_client_selected',
			id_user_language_selected: 'common/id_user_language_selected',
			num_rows: 'datatable/num_rows',
		}),

		getHeader() {
			let headers = {}
			return (headers = {
				headers: {
					'content-type': 'application/json',
					authorization:
						'Basic ' +
						btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
					authorization: 'Bearer ' + this.access_token,
				},
			})
		},

		getMaxWidth() {
			if (this.$q.platform.is.mobile) return '100vw'
			else return '80vw'
		},

		getMinWidth() {
			if (!this.$q.platform.is.mobile) return '90vw'
		},

		useTrailSubscription() {
			let client = this.clients.find((obj) => {
				return obj.id === this.id_user_client_selected
			})
			if (client) return client.use_trail_subscription
			else return false
		},
	},

	methods: {
		requestCertificates({ pagination }) {
			this.certificates = []
			this.loading = true
			this.server_pagination = pagination

			let order = pagination.descending ? '-' : ''
			let order_by = pagination.sortBy ? order + pagination.sortBy : ''

			let data = {
				page_size: this.server_pagination.rowsPerPage,
				page: this.server_pagination.page,
				ordering: order_by,
				search: this.filter_users,
			}

			this.savePagination()

			this.$axios
				.get(
					`admin_trails/trails/${this.id}/trail_users_results/?${this.$qs.stringify(
						data
					)}`,
					this.getHeader
				)
				.then((response) => {
					this.server_pagination.rowsNumber = response.data.count
					response.data.results.map((e) => {
						this.certificates.push({
							id: e.id,
							percent: e.percent,
							result_date: e.result_date
								? date.formatDate(e.result_date, 'DD/MM/YYYY HH:mm:ss')
								: '',
							score: e.score,
							status: e.status,
							user_branches: e.user_branches ? e.user_branches : [],
							user_email: e.user_email,
							user_full_name: e.user_full_name,
							user_id: e.user_id,
							user_id: e.user_profile,
						})
					})

					this.loading = false
				})
				.catch((e) => {
					this.loading = false
					console.log(e)
				})
		},

		requestMandatoryCertificates({ pagination }) {
			if (this.id) {
				this.loading = true
				this.mandatory = []
				this.server_pagination_mandatory = pagination

				let order = pagination.descending ? '-' : ''
				let order_by = pagination.sortBy ? order + pagination.sortBy : ''

				let data = {
					page_size: this.server_pagination_mandatory.rowsPerPage,
					page: this.server_pagination_mandatory.page,
					ordering: order_by,
					search: this.filter_certificates_mandatory,
				}

				this.savePagination()

				this.$axios
					.get(
						`/admin_trails/trails/${
							this.id
						}/trail_users_mandatory/?${this.$qs.stringify(data)}`,
						this.getHeader
					)
					.then((response) => {
						this.server_pagination_mandatory.rowsNumber = response.data.count

						this.mandatory = response.data.results.map((e) => {
							return {
								...e,
								result_date: e.result_date
									? date.formatDate(e.result_date, 'DD/MM/YYYY HH:mm:ss')
									: '',
							}
						})
					})
					.catch((e) => {
						console.log(e)
					})
					.finally(() => {
						this.loading = false
					})
			}
		},

		requestEnrolledCertificates({ pagination }) {
			if (this.id) {
				this.loading = true
				this.enrolled = []
				this.server_pagination_enrolled = pagination

				let order = pagination.descending ? '-' : ''
				let order_by = pagination.sortBy ? order + pagination.sortBy : ''

				let data = {
					page_size: this.server_pagination_enrolled.rowsPerPage,
					page: this.server_pagination_enrolled.page,
					ordering: order_by,
					search: this.filter_certificates_enrolled,
				}

				this.savePagination()

				this.$axios
					.get(
						`/admin_trails/trails/${
							this.id
						}/trail_users_subscribed/?${this.$qs.stringify(data)}`,
						this.getHeader
					)
					.then((response) => {
						this.server_pagination_enrolled.rowsNumber = response.data.count

						this.enrolled = response.data.results.map((e) => {
							return {
								...e,
								result_date: e.result_date
									? date.formatDate(e.result_date, 'DD/MM/YYYY HH:mm:ss')
									: '',
								actions: e.id,
							}
						})
					})
					.catch((e) => {
						console.log(e)
					})
					.finally(() => {
						this.loading = false
					})
			}
		},

		requestNotifyUsers({ pagination }) {
			this.users_notify = []
			this.loading = true
			this.server_pagination = pagination

			let order = pagination.descending ? '-' : ''
			let order_by = pagination.sortBy ? order + pagination.sortBy : ''

			let data = {
				page_size: this.server_pagination.rowsPerPage,
				page: this.server_pagination.page,
				ordering: order_by,
				search: this.filter,
			}

			this.savePagination()

			this.$axios
				.get(
					`admin_trails/trails/${
						this.id
					}/trail_users_results/list_undone_users/?${this.$qs.stringify(data)}`,
					this.getHeader
				)
				.then((response) => {
					this.server_pagination.rowsNumber = response.data.count

					this.users_notify = response.data.results.map((e) => {
						return { ...e, selected: false }
					})
				})
				.catch((e) => {
					console.log(e)
				})
				.finally(() => {
					this.loading = false
				})
		},

		showNotifyUsers() {
			this.requestNotifyUsers({ pagination: this.server_pagination })
			this.show_notify_users = true
		},

		confirmTypeNotification(type) {
			this.type_notification = type
			this.show_select_notification_message = true
		},

		showPersonalizeMessage() {
			this.show_select_notification_message = false
			this.personalize_message = true
		},

		notifyUsers(type) {
			this.type_message = type

			this.$v.$touch()

			if (!this.$v.$error) {
				this.personalize_message = false
				this.show_select_notification_message = false

				let data = {}

				if (this.type_notification === 'selected') {
					data.users_selection = this.users_notify_selected.map((e) => e.user_id)
				}

				if (this.type_message === 'personalized') {
					data.subject = this.notification_title
					data.message = this.notification_body
				}

				this.$q.loading.show()

				this.$axios
					.post(
						`admin_trails/trails/${
							this.id
						}/trail_users_results/notificate_undone_users/`,
						data,
						this.getHeader
					)
					.then((response) => {
						this.users_notified = true
					})
					.catch((e) => {
						console.log(e)
					})
					.finally(() => {
						this.show_notify_users = false
						this.users_notify_selected = []
						this.notification_title = ''
						this.notification_body = ''
						this.$v.$reset()

						this.$q.loading.hide()
					})
			}
		},

		getTextStatus(status) {
			if (status === 1) return 'approved'
			else if (status === 2) return 'reproved'
			else if (status === 3) return 'ongoing'
			else if (status === 4) return 'not_started'
			else return 'pending'
		},

		getColorStatus(status) {
			if (status === 1) return 'positive'
			else if (status === 2) return 'negative'
			else if (status === 3) return 'primary'
			else if (status === 4) return 'warning'
			else return 'tertiary'
		},

		getIconStatus(status) {
			if (status === 1) return 'fal fa-check'
			else if (status === 2) return 'fal fa-times'
			else if (status === 3) return 'fal fa-walking'
			else if (status === 4) return 'fal fa-clock'
			else return 'fal fa-clock'
		},

		getOrder(name) {
			if (name == 'cancel') {
				if (this.$q.platform.is.mobile) return 'order-last'
				else return 'order-first'
			} else if (name == 'save') {
				if (this.$q.platform.is.mobile) return 'order-first'
				else return 'order-last'
			}
		},

		fDate(d) {
			if (d) {
				let format = ''

				switch (this.id_user_language_selected) {
					case 1:
					case 3:
						format = 'DD/MM/YYYY HH:mm:ss'
						break
					default:
						format = 'MM-DD-YYYY HH:mm:ss'
						break
				}

				return date.formatDate(d, format)
			}
		},

		savePagination() {
			this.$store.dispatch('datatable/SET_NUM_ROWS', [this.server_pagination.rowsPerPage])
		},

		loadPagination() {
			this.server_pagination.rowsPerPage = this.num_rows
		},

		downloadCertificate() {
			let message = this.$t('generating_import_file_message')
			this.$q.loading.show({
				message,
			})
			this.$axios
				.get(
					`admin_trails/trails/${this.id}/trail_users_results/generate_report/`,
					this.getHeader
				)
				.then((response) => {
					this.forceFileDownload(response.data.path_url)
				})
				.catch((e) => {
					this.loading = false
					console.log(e)
				})
				.finally(() => {
					this.$q.loading.hide()
				})
		},

		forceFileDownload(response) {
			const link = document.createElement('a')
			link.href = response
			document.body.appendChild(link)
			link.click()
		},

		showEnrollUsers() {
			this.users_to_enroll = []
			this.selected_users_to_enroll = []
			this.filter_certificates_users_to_enroll = ''
			this.show_enroll_users = true

			this.requestUsersToEnroll({
				pagination: {
					page: 1,
					rowsNumber: 10,
					rowsPerPage: 5,
					descending: false,
					sortBy: null,
				},
			})
		},

		requestUsersToEnroll({ pagination }) {
			this.loading = true
			this.users_to_enroll = []
			this.server_pagination_users_to_enroll = pagination

			let order = pagination.descending ? '-' : ''
			let order_by = pagination.sortBy ? order + pagination.sortBy : ''

			let data = {
				page_size: this.server_pagination_users_to_enroll.rowsPerPage,
				page: this.server_pagination_users_to_enroll.page,
				ordering: order_by,
				search: this.filter_certificates_users_to_enroll,
			}

			this.savePagination()

			this.$axios
				.get(
					`/admin_trails/trails/${
						this.id
					}/trail_users_subscribed/list_users_to_subscribe/?${this.$qs.stringify(data)}`,
					this.getHeader
				)
				.then((response) => {
					this.server_pagination_users_to_enroll.rowsNumber = response.data.count
					this.users_to_enroll = response.data.results.map((e) => {
						return { ...e, selected: false }
					})
				})
				.catch((e) => {
					console.log(e)
				})
				.finally(() => {
					this.loading = false
				})
		},

		enrollUsers() {
			this.$q.loading.show()

			let data = {
				users: this.selected_users_to_enroll.map((e) => e.id),
			}

			this.$axios
				.put(
					`/admin_trails/trails/${this.id}/trail_users_subscribed/subscribe_users/`,
					data,
					this.getHeader
				)
				.then((response) => {
					this.requestEnrolledCertificates({
						pagination: {
							page: 1,
							rowsNumber: 10,
							rowsPerPage: 5,
							descending: false,
							sortBy: null,
						},
					})

					this.show_enroll_users = false
				})
				.catch((e) => {
					console.log(e)
				})
				.finally(() => {
					this.$q.loading.hide()
				})
		},

		removeEnrolledUser(user) {
			this.$q.loading.show()

			let data = {
				users: [user],
			}

			this.$axios
				.put(
					`/admin_trails/trails/${this.id}/trail_users_subscribed/unsubscribe_users/`,
					data,
					this.getHeader
				)
				.then((response) => {
					this.requestEnrolledCertificates({
						pagination: {
							page: 1,
							rowsNumber: 10,
							rowsPerPage: 5,
							descending: false,
							sortBy: null,
						},
					})
				})
				.catch((e) => {
					console.log(e)
				})
				.finally(() => {
					this.$q.loading.hide()
				})
		},

		getTextStatusEnrolled(user) {
			if (!user.status && user.is_self_subscribed) return 'self_enrolled'
			else if (!user.status && !user.is_self_subscribed) return 'enrolled'
			else if (user.status === 1) return 'approved'
			else if (user.status === 2) return 'reproved'
			else if (user.status === 3) return 'ongoing'
			else if (user.status === 4) return 'not_started'
			else return 'pending'
		},

		getColorStatusEnrolled(user) {
			if (!user.status && user.is_self_subscribed) return 'tertiary'
			else if (!user.status && !user.is_self_subscribed) return 'tertiary'
			else if (user.status === 1) return 'positive'
			else if (user.status === 2) return 'negative'
			else if (user.status === 3) return 'primary'
			else if (user.status === 4) return 'warning'
			else return 'tertiary'
		},

		getIconStatusEnrolled(user) {
			if (!user.status && user.is_self_subscribed) return 'fal fa-user'
			else if (!user.status && !user.is_self_subscribed) return 'fal fa-users-class'
			else if (user.status === 1) return 'fal fa-check'
			else if (user.status === 2) return 'fal fa-times'
			else if (user.status === 3) return 'fal fa-walking'
			else if (user.status === 4) return 'fal fa-clock'
			else return 'fal fa-clock'
		},
	},

	watch: {
		load: function() {
			if (this.load) {
				if (!this.useTrailSubscription)
					this.requestCertificates({ pagination: this.server_pagination })
				else
					this.requestMandatoryCertificates({
						pagination: this.server_pagination_mandatory,
					})
			} else {
				this.report = 'mandatory'
			}
		},

		num_rows: {
			handler: function(newValue) {
				this.loadPagination()
			},
			deep: true,
		},

		report: function() {
			if (this.report === 'mandatory') {
				this.requestMandatoryCertificates({
					pagination: {
						page: 1,
						rowsNumber: 10,
						rowsPerPage: 5,
						descending: false,
						sortBy: null,
					},
				})
			} else if (this.report === 'enrolled') {
				this.requestEnrolledCertificates({
					pagination: {
						page: 1,
						rowsNumber: 10,
						rowsPerPage: 5,
						descending: false,
						sortBy: null,
					},
				})
			}
		},
	},

	mounted() {
		this.loadPagination()
		if (!this.useTrailSubscription)
			this.requestCertificates({ pagination: this.server_pagination })
		else this.requestMandatoryCertificates({ pagination: this.server_pagination_mandatory })
	},

	validations() {
		return {
			notification_title: {
				requiredIf: requiredIf(() => {
					return this.type_message === 'personalized'
				}),
			},
			notification_body: {
				requiredIf: requiredIf(() => {
					return this.type_message === 'personalized'
				}),
			},
		}
	},
}
</script>

<style></style>
